import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminChargingReports = lazy(() => import("@/pages/admin/AdminChargingReports"));

export const Route = createFileRoute("/admin/laddstationer")({
  component: () => <AdminChargingReports />,
});
